export default function MapPopUpTags({ text, tags }) {
  return (
    <div className="popup-tags-group">
      <div className="popup-tags-label">{text}</div>
      <div className="popup-tags">
        {tags.map((tag) => (
          <span className="popup-tag" key={tag.Name}>{tag.Name}</span>
        ))}
      </div>
    </div>
  );
}
